import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { BasicCheckbox } from 'src/components/shared/form/BasicCheckbox'

interface Props {
  name: string
  label: string
  checked: boolean
  onChange(checked: boolean): void
}

// Borderless, with the label in 14px semibold dark grey and a matching dark grey tick rather
// than BasicCheckbox's bordered 16px purple form-field look.
const toolbarCheckboxCss = tw`flex h-[38px] items-center [& .MuiFormControlLabel-root]:border-0 [& .MuiFormControlLabel-root]:p-0 [& .MuiTypography-root]:text-sm [& .MuiTypography-root]:font-semibold [& .MuiTypography-root]:text-shades-600 [& .MuiCheckbox-root]:text-shades-600 [& .MuiCheckbox-root.Mui-checked]:text-shades-600`

/**
 * A filter toggle for a `ToolbarRow`. Its box is the height of the row's selects (38px) and
 * centres the checkbox in it, so on a bottom-aligned row it lines up with the inputs beside it.
 */
const ToolbarCheckboxComponent = ({ name, label, checked, onChange }: Props) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<any>) => {
      onChange(Boolean(event.target.checked))
    },
    [onChange],
  )

  return (
    <div css={toolbarCheckboxCss}>
      <BasicCheckbox name={name} label={label} value={checked} onChange={handleChange} />
    </div>
  )
}

export const ToolbarCheckbox = memo(ToolbarCheckboxComponent)
